import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=0fefd23e&scoped=true&lang=pug&"
import script from "./ProjectPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=0fefd23e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefd23e",
  null
  
)

export default component.exports